module.exports = __webpack_public_path__ + "static/luces-en-la-carcel-3fe2d803d7e411998a01571a183b5a9c.jpg";